// ----------------------------------------------------------------------
// <copyright file="Izenda.Measure.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var PropTypes = React.PropTypes;

  var observer = require('mobx-react').observer;
  var observable = require('mobx').observable;
  var fastdom = require('fastdom');
  var elementResizeDetector = require('share/utils/Izenda.SizeDetector');
  var DEFAULT_DEBOUNCE_TIME = 450;
  const { debounce, isNil, omit } = require('lodash/fp');
  var Measure = React.createClass({
    propTypes: {
      children: PropTypes.element,
      measureBeforeMount: PropTypes.bool,
      onChange: PropTypes.func
    },
    getDefaultProps: function() {
      return {
        measureBeforeMount: false
      };
    },

    componentWillMount: function() {
      this.dimensionState = observable({
        mounted: false
      });
    },

    onChange: function(element) {
      var onChange = this.props.onChange;
      fastdom.measure(function() {
        element && onChange && onChange(element.clientWidth, element.clientHeight);
      });
    },

    initListener: function(domNode) {
      var listener = domNode && elementResizeDetector.listenTo(domNode, debounce(DEFAULT_DEBOUNCE_TIME, this.onChange));

      // this.onChange(domNode);

      this.domNode = domNode;
      this.listener = listener;
    },

    componentDidMount: function() {
      var domNode = ReactDOM.findDOMNode(this);
      this.dimensionState.mounted = true;
      this.initListener(domNode);
      this.onChange(domNode);
    },

    componentDidUpdate: function(prevProps, prevState) {
      var domNode = ReactDOM.findDOMNode(this);
      if (this.listener && this.domNode !== domNode) {
        elementResizeDetector.removeListener(this.domNode, this.listener);
        this.initListener(domNode);
      }
    },

    componentWillUnmount: function() {
      var domNode = ReactDOM.findDOMNode(this);
      !isNil(domNode) && elementResizeDetector.removeAllListeners(domNode);
    },

    render: function() {
      if (this.props.measureBeforeMount && !this.dimensionState.mounted)
        return (
          <div style={{ width: this.dimensionState.width }} {...omit(['measureBeforeMount', 'children'], this.props)} />
        );

      return this.props.children;
    }
  });

  module.exports = observer(Measure);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Measure.jsx